import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const CalendarAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.CALENDAR}
      title="Activity Calendar Automation"
      breadcrumb="Activity Calendar"
      module="calendar"
    />
  );
};

export default CalendarAutomation;
